import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, AlertController } from 'ionic-angular';
import { Uploads } from "../../services/uploads";
import { Globals } from "../../../globals";
import { ConfigurationImagesPage } from '../configuration-images/configuration-images';
import { ConfigurationEstablishmentCreatePage } from '../configuration-establishment/configuration-establishment-create/configuration-establishment-create';
import { ConfigurationServices } from '../services';
import { HttpClient } from '@angular/common/http';
import { MenuListPage } from '../../menu/menu-list/menu-list';
import { CartaListPage } from '../../carta/carta-list/carta-list';
import { ConfigurationIntegrationsPage } from '../configuration-integrations/configuration-integrations';
import { FormBuilder, Validators } from '@angular/forms';
import * as firebase from 'firebase';
import { ConfigurationRestWebZipcodePage } from './configuration-rest-web-zipcode/configuration-rest-web-zipcode';
import { ConfigurationRestWebSchedulePage } from './configuration-rest-web-schedule/configuration-rest-web-schedule';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationDomainsPage } from '../configuration-domains/configuration-domains';
import { ConfigurationRestWebEditCartaPage } from './configuration-rest-web-edit-carta/configuration-rest-web-edit-carta';
import { ComboCreateCustomizeViewPage } from '../../combo/combo-view/combo-create-customize-view';
import { MenuCreateCustomizeViewPage } from '../../menu/menu-view/menu-create-customize-view';
import { StaticsServices } from '../../services/statics';
import { QRServices } from '../../services/qrServices';
/**
 * Generated class for the ConfigurationImagesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-rest-web',
  templateUrl: 'configuration-rest-web.html',
})
export class ConfigurationRestWebPage {

  domini: any;
  dominiForm: any;
  firestore;
  payments_ok: boolean;
  actual_day: any;
  schedule: any;
  selectedFiles: FileList;
  img_ref: string = null;
  all_menuscartas_active: any;
  horaryForm: any;
  config_horary: false;
  policy: string = '';
  _policy: string = '';
  web_text_large_aboutus: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public uploadServices: Uploads,
    public globals: Globals,
    private configurationServices: ConfigurationServices,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    private http: HttpClient,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public staticsServices: StaticsServices,
    public translateService: TranslateService,
    public qrServices: QRServices,) {

    this.firestore = firebase.firestore();
    this.configurationServices.getRestaurant(this.globals.restaurant_uid);
    //
    this.dominiForm = this.fb.group({
      domini: ['', [Validators.required, Validators.pattern("[a-z0-9.-]{1,}")]],
    });

    this.horaryForm = this.fb.group({
      web_tk_open_hour: [this.globals.restaurant.web_tk_open_hour],
      web_tk_close_hour: [this.globals.restaurant.web_tk_close_hour],
      interval_between_orders: [this.globals.restaurant.interval_between_orders],
      number_orders: [this.globals.restaurant.number_orders],
    });

    this.web_text_large_aboutus = globals.restaurant.web_text_large_aboutus;
  }

  ionViewDidEnter() {
    this.domini = this.globals.domini_sites;
    this.getMenusCartas();
    this.getCP();
    this.checkStripe();
    this.checkDeliveriesOptions();
    this.getActualDay();
    this.getInit_Policy();
  }

  async getInit_Policy() {
    if (this.globals.restaurant.privacy_policy != undefined) {
      this._policy = this.globals.restaurant.privacy_policy;
    } else {
      var config = await this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').get();
      this._policy = config.data().privacy_policy;
      //
      this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'privacy_policy': this._policy,
      });
      this.globals.restaurant.privacy_policy = this._policy;
    }
  }

  ionViewWillEnter() {
    this.config_horary = this.navParams.get('config_horary');
    if (this.config_horary) {
      document.getElementById("focusHorary").focus();
    }

  }

  async getMenusCartas() {
    this.all_menuscartas_active = await this.configurationServices.getMenusCartasTKActive();
  }

  checkDeliveriesOptions() {
    //Comprovamos si las opciones de delivery son undefined
    if (this.globals.restaurant.web_table == undefined) {
      this.globals.restaurant.web_table = true;
    }
    if (this.globals.restaurant.web_delivery == undefined) {
      this.globals.restaurant.web_delivery = true;
    }
    if (this.globals.restaurant.web_pickup == undefined) {
      this.globals.restaurant.web_pickup = true;
    }
    if (this.globals.restaurant.web_tk_horary == undefined) {
      this.globals.restaurant.web_tk_horary = false;
    }
  }

  editImages() {
    this.globals.side_menu_config_active = 'images';
    this.navCtrl.push(ConfigurationImagesPage);
  }

  editContact() {
    this.globals.side_menu_config_active = "establishment";
    this.navCtrl.push(ConfigurationEstablishmentCreatePage, {
      update_state: true,
      restaurant: this.configurationServices.restaurant,
    });
  }

  openCartas() {
    this.navCtrl.push(CartaListPage);
  }
  openMenus() {
    this.navCtrl.push(MenuListPage);
  }

  openIntegrations() {
    this.globals.side_menu_config_active = 'integrations';
    this.navCtrl.push(ConfigurationIntegrationsPage);
  }

  updateReservations(reservations) {
    this.globals.restaurant.reservations_web = reservations;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'reservations_web': reservations,
    });
  }

  updateDeliveries(table, delivery, pickup, web_tk_horary) {
    this.globals.restaurant.web_table = table;
    this.globals.restaurant.web_delivery = delivery;
    this.globals.restaurant.web_pickup = pickup;
    this.globals.restaurant.web_tk_horary = web_tk_horary;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_table': table,
      'web_delivery': delivery,
      'web_pickup': pickup,
      'web_tk_horary': web_tk_horary,
    });
  }

  async getDomini() {
    const publicKeyRef = this.firestore.collection('public_key');
    //Recuperem el domini del restaurant
    await publicKeyRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let data = doc.data();
          //Si tiene el addon pro cogemos el dominio
          if (this.globals.checkLimitsByLicense('sites', 'web_config')) {
            if (data.domini == undefined) {
              this.domini = doc.id;
            } else {
              this.domini = data.domini;
            }
          } else {
            this.domini = doc.id;
          }
        });
      });
  }

  async saveDomini() {
    //Modifiquem el domini del restaurant
    this.configurationServices.afs.collection('public_key').doc(this.globals.public_key).update({
      'domini': this.domini,
    });
    this.globals.domini_sites = this.domini;
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-dominio-guardado'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
  async check() {
    //Comprovamos limites de la licencia
    if (this.globals.checkLimitsByLicense('sites', 'web_config')) {
      if (!this.dominiForm.valid) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-acepta-minusculas-puntos-guiones'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
      } else {
        //Si checkDomini retorna falso, podemos crear el dominio para el restaurante. Si no es que ja existe el dominio
        let domini_exists = await this.checkDomini();
        if (!domini_exists) {
          this.saveDomini();
          //Enviamos un msg a slack
          var msg = this.translate.instant('general-dominio-configurado-de') + ' ' + this.globals.restaurant.email + ' ' + this.translate.instant('general-nombre-restaurante') + " " + this.globals.restaurant.company + '.';
          this.sendSlack(msg);
        } else {
          let toast = this.toastCtrl.create({
            message: this.translate.instant('general-este-domino-existe'),
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }

  }
  async checkDomini() {
    const publicKeyRef = this.firestore.collection('public_key');
    let domini_exists = false;
    await publicKeyRef.where('domini', '==', this.domini)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          if (doc.data()) {
            domini_exists = true;
          }
        });
      });
    return domini_exists;
  }


  async getCP() {
    this.configurationServices.getCP();
  }
  editZipCodes() {
    this.navCtrl.push(ConfigurationRestWebZipcodePage, {
      zip_codes: this.configurationServices.zip_codes
    });
  }

  checkStripe() {
    if (this.globals.restaurant.connected_acount && this.globals.restaurant.facturacion_id) {
      this.payments_ok = true;
    } else {
      this.payments_ok = false;
    }
  }

  editSchedule() {
    this.navCtrl.push(ConfigurationRestWebSchedulePage);
  }
  saveSendingPrice() {
    //Modifiquem els preus de envio
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_free_sending': this.globals.ifNumEmpty(this.globals.restaurant.web_free_sending),
      'web_sending_price': this.globals.ifNumEmpty(this.globals.restaurant.web_sending_price),
      'web_aprox_delivery_time': this.globals.ifVarEmpty(this.globals.restaurant.web_aprox_delivery_time),
      'web_tk_min_order': this.globals.ifNumEmpty(this.globals.restaurant.web_tk_min_order),
    });
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-precios-envio-guardados'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  saveOfertas() {
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_offer': this.globals.ifNumEmpty(this.globals.restaurant.web_offer),
      'web_amount_to_offer': this.globals.ifNumEmpty(this.globals.restaurant.web_amount_to_offer),
    });
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-ofertas-guardadas'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  async sendSlack(msg) {
    await this.http.post(this.globals.api_path + 'slack/integrations', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {
      }
    );
  }

  getActualDay() {
    this.actual_day = new Date();
    switch (moment(this.actual_day).format('dddd')) {
      case "Monday": {
        this.schedule = this.globals.restaurant.web_schedule_monday;
        break;
      }
      case "Tuesday": {
        this.schedule = this.globals.restaurant.web_schedule_tuesday;
        break;
      }
      case "Wednesday": {
        this.schedule = this.globals.restaurant.web_schedule_wednesday;
        break;
      }
      case "Thursday": {
        this.schedule = this.globals.restaurant.web_schedule_thursday;
        break;
      }
      case "Friday": {
        this.schedule = this.globals.restaurant.web_schedule_friday;
        break;
      }
      case "Saturday": {
        this.schedule = this.globals.restaurant.web_schedule_saturday;
        break;
      }
      case "Sunday": {
        this.schedule = this.globals.restaurant.web_schedule_sunday;
        break;
      }
    }
  }

  selectHorary() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();


    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_tk_open_hour': this.horaryForm.value.web_tk_open_hour,
      'web_tk_close_hour': this.horaryForm.value.web_tk_close_hour,
      'interval_between_orders': this.horaryForm.value.interval_between_orders,
      'number_orders': this.horaryForm.value.number_orders,
    }).then(() => {
      loadingPopup.dismiss();
      this.globals.restaurant.web_tk_open_hour = this.horaryForm.value.web_tk_open_hour;
      this.globals.restaurant.web_tk_close_hour = this.horaryForm.value.web_tk_close_hour;
      this.globals.restaurant.interval_between_orders = this.horaryForm.value.interval_between_orders;
      this.globals.restaurant.number_orders = this.horaryForm.value.number_orders;
      //
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-horario-guardado'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }).catch(() => {
      loadingPopup.dismiss();
    });
  }

  openDomainConfig() {
    this.navCtrl.push(ConfigurationDomainsPage);
  }

  editarCarta(carta) {
    this.navCtrl.push(ConfigurationRestWebEditCartaPage, {
      carta: carta
    });
  }

  editarCombo(combo) {
    this.navCtrl.push(ComboCreateCustomizeViewPage, {
      menu_uid: combo.UID,
    });
  }

  editarMenu(menu) {
    this.navCtrl.push(MenuCreateCustomizeViewPage, {
      menu_uid: menu.UID,
    });
  }

  activateFeatured(element) {
    //actualizamos visualmente
    var index = this.all_menuscartas_active.findIndex(x => x.UID == element.UID);
    this.all_menuscartas_active[index].featured = true;
    //update en firebase
    this.configurationServices.afs.collection('menus').doc(element.UID).update({
      'featured': true,
    });
    //activamos statics
    this.staticsServices.changeStateStaticWait(true);
  }

  desactivateFeatured(element) {
    //actualizamos visualmente
    var index = this.all_menuscartas_active.findIndex(x => x.UID == element.UID);
    this.all_menuscartas_active[index].featured = false;
    //update en firebase
    this.configurationServices.afs.collection('menus').doc(element.UID).update({
      'featured': false,
    });
    //activamos statics
    this.staticsServices.changeStateStaticWait(true);
  }

  openCloseTk(web_tk_active) {

    this.globals.restaurant.web_tk_active = web_tk_active;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_tk_active': web_tk_active,
    });
  }

  public getInitPolicy(editor: any) {
    if (editor.html) {
      this.policy = editor.html;
    }
  }

  savePolicy() {
    this.configurationServices.afs.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
      privacy_policy: this.policy
    }).then(ref => {
      let toast = this.toastCtrl.create({
        message: this.translateService.instant('general-guardado-correctamente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    });
    //
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      privacy_policy: this.policy
    }).then(ref => {
      this.globals.restaurant.privacy_policy = this.policy;
    });
  }

  generateQrTK() {
    this.qrServices.generateTakeawayQR();
  }

  public getWebTextAboutUs(editor: any) {
    if (editor.event == "text-change") {
      if (editor.html) {
        this.web_text_large_aboutus = editor.html;
      } else {
        this.web_text_large_aboutus = '';
      }
    }
  }
  saveWebTextAboutUs() {
    this.globals.restaurant.web_text_large_aboutus = this.web_text_large_aboutus;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_text_large_aboutus': this.web_text_large_aboutus,
    });
    let toast = this.toastCtrl.create({
      message: this.translateService.instant('general-guardado-correctamente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rest-web/configuration-rest-web.ts